import * as React from 'react';
import { useEffect,useState } from 'react';
import FaceService from '../services/face.service';
import FaceComponent from '../components/FaceMatch.Component';
import {IFaceMatch } from '../@types/FaceMatch';
import {IsFaceMatch} from '../helpers/checkIsType';
import { handleHttpError } from '../helpers/HttpErrorHandler';
import '../hotDeals.css';

const HotDeals:React.FC = () => {

    const adRandomNum = Math.ceil(Math.random() * 2);

    const [loading, setLoading] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>("");
    const [faces,popFaceData] = React.useState<IFaceMatch[]>([]);

    const faceService = FaceService.getInstance();

    useEffect(()=>{ 
      document.title = 'Camgirl hot deals!';
      let descMeta=document.querySelector("meta[name='description']");
      if(descMeta!==null)descMeta.setAttribute("content", 'Camgirl models offering private room sessions at great discounts');
      let canNAme=document.querySelector("link[rel='canonical']");
      if(canNAme!==null)canNAme.setAttribute("href", 'https://www.camgirlcrawler.net/camgirl-hot-deals');

        getHotDeals();
       }, []); // empty array means only once

      const getHotDeals = () =>
      {
        setErrorMsg("");
        setLoading(true);

        faceService.getHotDeals().then(response => { 
          if(response.length >0 && IsFaceMatch(response[0])){
            const toDo = response as IFaceMatch[];
            toDo.forEach(fm =>{fm.numberOfImages = -1})
            popFaceData(response);
            }else{
              popFaceData([]);
              setErrorMsg(handleHttpError(response));
          } 
        }).catch(error => {
          setErrorMsg(handleHttpError(500));
          //console.log(error)
          console.clear();
        }).then(() =>{
              setLoading(false);
        });
      }
    return (
        <div>       
            <div className='pageHeader'>
              <section>
              <h1>Camgirl Hot Deals!</h1>
              <div><b><i>Welcome to our camgirl Hot Deals page. Find camgirl deals and discounts!</i></b></div>
              </section>
            </div> 
            <div style={{marginBottom: '30px'}}>  
              <a href="https://www.latinalovely.cam/" rel="sponsored"  target='_blank' >		  
                <picture>
                  <source media="(max-width:768px)" srcSet="images/latinalovely-420x80.gif"/>
                      <img src="images/latinalovely.gif" alt="Latina lovely sex webcam site" max-width="600px" height="auto"/>
                </picture>
                </a>  
            </div>
          {adRandomNum==1 ? (
            <div>  
              <div id="ads">
                <a href='https://chaturbate.com/in/?tour=JpRf&campaign=yLHL1&track=default&next=/female-cams/' rel="sponsored" target="_blank">
                  <img src='images/cb_728x90.webp' className="responsiveAd"/>
                </a>
              </div>
              <div id="ads_m">
                <a href='https://chaturbate.com/in/?tour=JpRf&campaign=yLHL1&track=default&next=/female-cams/' rel="sponsored" target="_blank">
                  <img src='images/cb_468x60b.webp' className="responsiveAd"/>
                </a>
              </div>
              <div id="ads_sm">
                <a href='https://chaturbate.com/in/?tour=JpRf&campaign=yLHL1&track=default&next=/female-cams/' rel="sponsored" target="_blank">
                  <img src='images/cb_300x250.webp' className="responsiveAd"/>
                </a>
              </div>
            </div>
          ):(
          <div>
            <div style={{display: 'inline-block'}}>
              <a href='https://stripchat.com/?affiliateId=130725b6hbbrhk3mjasl26mh8hvf0qtetowttnj5nxjcvc7oagurq0oduwby9m57&bb=7309543c.png&i=0&modelsCount=0&path=%2F&realDomain=go.rmhfrtnd.com&referrer=https%3A%2F%2Fcreative.rmhfrtnd.com%2F&stripbotVariation=NullWidget&userId=e4ba57e368d2397052ee3d997efa5de75468285be53c34b084a63ef7e697bfbb' rel="sponsored" target="_blank">
                <img src='images/753094b3.gif'/>
              </a>
            </div>
            <div style={{display: 'inline-block'}}>
              <a href='https://stripchat.com/?affiliateId=130725b6hbbrhk3mjasl26mh8hvf0qtetowttnj5nxjcvc7oagurq0oduwby9m57&bb=7309543c.png&i=0&modelsCount=0&path=%2F&realDomain=go.rmhfrtnd.com&referrer=https%3A%2F%2Fcreative.rmhfrtnd.com%2F&stripbotVariation=NullWidget&userId=e4ba57e368d2397052ee3d997efa5de75468285be53c34b084a63ef7e697bfbb' rel="sponsored" target="_blank">
                <img src='images/7309543c.png'/>
              </a>
            </div>
          </div>
          )}
            <br/>         
            <div>{loading && faces.length===0 &&(                       
                  <img src={'images/spinner.gif'} alt="Loading"  width={'25px'}/>
                  )}
            </div>  
            {errorMsg && (
              <div className="alert alert-danger errorMessage" role="alert">
                {errorMsg}
              </div>
              )}
            {!errorMsg && faces.length>0 && (
            <div className='info' id='info'>            
                  <section>See below camgirls offering private room sessions at great discounts!</section>
            </div>
            )}
            <div className='resultsThumbsOutter'>
              {!errorMsg && faces.length>0 &&  faces.map((face: IFaceMatch) => (
                <FaceComponent key={face.name}  face={face} imgWidth='250' imgHeight='250' showLastSeen={false}/>
                  ))    
                } 
            </div>
          <br/><br/>
          <div id="ads">
            <a href='https://www.livejasmin.com/en/promotions?category=girls&psid=camgirlcrawler&pstool=429_26&psprogram=revs&utm_source=cr&utm_medium=webmaster&utm_campaign=hh70dc&utm_content=call+to+action&dpid=HZRJz%2FOHs&jumpReferrer=camgirlcrawler&mr=0' rel="sponsored" target="_blank">
              <img src='images/lj_70_L.png' className="responsiveAd"/>
            </a>
          </div>
          <div id="ads_m">
            <a href='https://www.livejasmin.com/en/promotions?category=girls&psid=camgirlcrawler&pstool=429_26&psprogram=revs&utm_source=cr&utm_medium=webmaster&utm_campaign=hh70dc&utm_content=call+to+action&dpid=HZRJz%2FOHs&jumpReferrer=camgirlcrawler&mr=0' rel="sponsored" target="_blank">
              <img src='images/lj_70_m.png' className="responsiveAd"/>
            </a>
          </div>
          <div id="ads_sm">
            <a href='https://www.livejasmin.com/en/promotions?category=girls&psid=camgirlcrawler&pstool=429_26&psprogram=revs&utm_source=cr&utm_medium=webmaster&utm_campaign=hh70dc&utm_content=call+to+action&dpid=HZRJz%2FOHs&jumpReferrer=camgirlcrawler&mr=0' rel="sponsored" target="_blank">
              <img src='images/lj_70_sm.png' className="responsiveAd"/>
            </a>
          </div>
        </div>
  );
}
export default HotDeals;